@if (authenticated && topSlot()) {
<div class="flex align-center z-0 lg:inset-x-0 lg:top-[4rem] bg-white border-b-neutral-200 border-b">
  <nav id="nav" class="w-full relative lg:py-2 lg:px-6">
    <ng-content select="[left]"></ng-content>
  </nav>
</div>
}

<div class="main-content-wrapper relative flex-1">
  @if (contentWithScroll()) {

  <p-scrollPanel styleClass="w-full h-full custombar">
    <ng-container *ngTemplateOutlet="coreContent"></ng-container>
  </p-scrollPanel>
  } @else {
  <ng-container *ngTemplateOutlet="coreContent"></ng-container>
  }
</div>

<ng-template #coreContent>
  <div [ngClass]="contentClass()">
    <ng-content></ng-content>
  </div>
</ng-template>
